module.exports = __webpack_public_path__ + "img/upload-request.038f540c.png";